import React from 'react'


const FiltrarVentas = () => {
    return ( 
        <>
            <h3>Filtrar</h3>
        </>
     );
}
 
export default FiltrarVentas;